import React from "react";
import { colors, radius, shadow } from "./tokens";

// Carte de statistique — un seul gabarit pour tous les modules (Dashboard/Payments) au lieu
// d'un style inline recopié à chaque écran. `icon` optionnel dans un médaillon teinté par `tone`.
export function StatCard({ label, value, tone = "accent", icon }: {
  label: string; value: React.ReactNode; tone?: "accent" | "success" | "danger" | "warning"; icon?: React.ReactNode;
}) {
  const tint = tone === "accent" ? colors.accentSoft : tone === "success" ? colors.successSoft : tone === "danger" ? colors.dangerSoft : colors.warningSoft;
  const fg = tone === "accent" ? colors.accent : tone === "success" ? colors.success : tone === "danger" ? colors.danger : colors.warning;
  return (
    <div style={{ backgroundColor: colors.card, border: `1px solid ${colors.border}`, borderRadius: radius.lg, boxShadow: shadow, padding: 20, flex: 1, minWidth: 180 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
        {icon && (
          <div style={{ width: 34, height: 34, borderRadius: radius.md, backgroundColor: tint, color: fg, display: "flex", alignItems: "center", justifyContent: "center" }}>
            {icon}
          </div>
        )}
        <div style={{ fontSize: 11, fontWeight: 700, color: colors.textMuted, textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
      </div>
      <div style={{ fontSize: 26, fontWeight: 800, color: colors.text, letterSpacing: -0.3 }}>{value}</div>
    </div>
  );
}
